import { useEffect } from "react";
import { UPDATE_FAV_BRANDS_URL } from "../conf";
import useData from "./useData";
import useIdentity from "./useIdentity";
import useResource from "./useResource";

const useRemoteBrandSaver = ({
	brandId = -1,
	saved = false,
	user = {},
} = {}) => {
	const { user: { email, name } = user } = useIdentity() || {};
	const { publisher, session_id } = useData();

	const [{ data, error }, updateRemoteFavBrands, resetRemoteFavBrands] =
		useResource(
			{
				url: UPDATE_FAV_BRANDS_URL,
				method: "POST",
				data: {
					brand_id: brandId,
					email,
					name,
					favorited: saved,
					publisher_id: publisher,
					session_id,
				},
			},
			false
		);

	useEffect(() => {
		if (!data && !error) return;
		resetRemoteFavBrands();
	}, [resetRemoteFavBrands, data, error]);

	return { updateRemoteFavBrands, resetRemoteFavBrands };
};
export default useRemoteBrandSaver;
